import {Base} from "@/api/Base"

export class RemainingVacationList extends Base {
    path = "remainingVacation/list"
}